import { actionToPath } from 'redux-first-router';
import queryString from 'querystring';
import { visitComponent } from './actions';
import routesMap from './routesMap';

/**
 * returns path to visit component
 * @param {string} id - id of the component
 * @param {string} version - version of the component
 * @param {string} locale - locale of the component
 * @returns {string} path to visit component
 */
export const visitComponentPath = (id, version, locale) =>
  actionToPath(visitComponent(id, version, locale), routesMap, queryString);
